<template>
  <sc-flex :is-column="true" :gap="2" class="debugx">
    <!-- Dialog: Rename -->
    <v-dialog
      max-width="1000px"
      v-model="previewDialogOpened"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      @keydown.esc="
        previewDialogOpened = false;
        documentPreviewData = '';
        previewRotation = 0;
      "
    >
      <v-card v-if="selectedItem">
        <v-card-title class="title">
          <v-layout v-if="renameFile" align-center>
            <span class="caption">New Name:</span>
            <v-text-field
              v-model="newName"
              hide-details
              solo
              class="default-input mx-2"
            />
            <span class="subheading">.{{ documentExtension }}</span>
            <v-tooltip bottom class="mx-2">
              <i
                class="material-icons-outlined success--text"
                style="font-size: 20px; cursor: pointer"
                @click="renameItem()"
                slot="activator"
              >
                check
              </i>
              <span>Save</span>
            </v-tooltip>
            <v-tooltip bottom class="ml-2">
              <i
                class="material-icons-outlined error--text"
                style="font-size: 20px; cursor: pointer"
                @click="renameFile = false"
                slot="activator"
              >
                cancel
              </i>
              <span>Cancel</span>
            </v-tooltip>
          </v-layout>
          <v-layout v-else align-center>
            {{ getDocumentName(selectedItem.source) }}
            <v-chip
              class="ml-2"
              small
              v-if="
                getDocumentName(selectedItem.source) !==
                  selectedItem.detailed_name &&
                  !isEmpty(selectedItem.detailed_name)
              "
              >{{ selectedItem.detailed_name }}</v-chip
            >
            <v-chip
              class="ml-2"
              small
              v-else-if="childrenSinglePage(selectedItem)"
              >{{ childDocuments(selectedItem)[0].detailed_name }}</v-chip
            >
            <!-- <v-tooltip bottom class="ml-2">
              <i class="material-icons-outlined primary--text" style="font-size:20px;cursor:pointer" @click="startRenaming()" slot="activator">
                edit
              </i>
              <span>Rename</span>
            </v-tooltip> -->
          </v-layout>

          <v-spacer />
          <!-- <v-tooltip bottom class="mr-1">
            <v-btn fab small flat class="white primary--text text-capitalize ma-0" @click="openIdentifyFormDialog()" slot="activator">
              <v-icon size="25">
                find_replace
              </v-icon>
            </v-btn>
            <span>Change Form Identification</span>
          </v-tooltip> -->
          <v-tooltip bottom class="mx-1">
            <v-btn
              fab
              small
              flat
              class="white primary--text text-capitalize ma-0"
              @click="previewRotation += 90"
              slot="activator"
            >
              <v-icon size="25"> rotate_right </v-icon>
            </v-btn>
            <span>Rotate</span>
          </v-tooltip>
          <v-tooltip bottom class="mx-1">
            <v-btn
              fab
              small
              flat
              class="white primary--text text-capitalize ma-0"
              @click="getLinkAndDownloadFile()"
              slot="activator"
            >
              <i
                class="material-icons-outlined primary--text"
                style="font-size: 25px"
              >
                get_app
              </i>
            </v-btn>
            <span>Download to Computer</span>
          </v-tooltip>
          <v-btn
            fab
            small
            flat
            class="white error--text text-capitalize ma-0 ml-1"
            @click="
              previewDialogOpened = false;
              documentPreviewData = '';
              previewRotation = 0;
            "
          >
            <v-icon size="25"> clear </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text v-if="documentPreviewData">
          <preview-document
            :document-preview-data="documentPreviewData"
            :preview-type="previewType"
            :preview-rotation="previewRotation"
            :current-company="currentCompany"
          />
        </v-card-text>
        <v-card-text v-else>
          <v-progress-circular
            indeterminate
            size="50"
            class="primary--text ma-5"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog: Comment -->
    <comment-dialog
      :opened.sync="commentDialogOpened"
      :editable="
        !currentQuestionnaire.locked && !currentQuestionnaire.completed
      "
      :selected-question="selectedQuestion"
      :current-company-id="currentQuestionnaire.company_id"
      @open-conversation="openRelevantConversation"
    />

    <!-- Dialog: Confirm Delete -->
    <ConfirmationDialog
      v-model="deleteQuestionConfirmationDialogOpened"
      @confirm="deleteQuestion(selectedQuestion.id)"
    >
      Are you sure you want to delete the question?
    </ConfirmationDialog>

    <!-- Dialog: Confirm Editing Engagement Letter -->
    <ConfirmationDialog
      v-model="editEngagementLetterConfirmationDialogOpened"
      @confirm="
        engagementLetterEditing = true;
        editEngagementLetterConfirmationDialogOpened = false;
      "
    >
      Are you sure you want to edit the engagement letter? The client will
      receive a notification that the engagement letter has been edited (if they
      made progress on the questionnaire)
    </ConfirmationDialog>

    <!-- Partial: Tabs -->
    <v-layout>
      <v-tabs
        v-model="active"
        color="white"
        slider-color="primary"
        class="mb-2"
        v-if="currentUser.is_advisor"
      >
        <v-tab key="questionnaire" ripple class="text-none subheading">
          <v-layout align-center>
            <span
              >{{ projectViewEnabled ? 'Steps' : 'Sections' }} ({{
                sections.filter(a => sectionCompleted(currentQuestionnaire, a))
                  .length
              }}/{{ sections.length }})</span
            >
          </v-layout>
        </v-tab>
        <v-tab key="documents" ripple class="text-none subheading">
          <v-layout align-center>
            <span v-if="oldDocumentChecklist"
              >Documents ({{ parentDocuments.length }})</span
            >
            <span v-else>Documents</span>
          </v-layout>
        </v-tab>
        <v-tab key="activities" ripple class="text-none subheading">
          <v-layout align-center>
            <span>Activities</span>
          </v-layout>
        </v-tab>
        <v-tab
          key="otherDocuments"
          ripple
          class="text-none subheading"
          v-if="recentlyUploadedDocuments.length > 0"
        >
          <v-layout align-center>
            <span>Unattached </span>
          </v-layout>
        </v-tab>
      </v-tabs>
      <v-spacer />
      <v-tooltip
        bottom
        v-if="currentUser.is_advisor && !currentQuestionnaire.track_changes"
      >
        <v-btn
          slot="activator"
          v-if="!currentQuestionnaire.is_draft"
          :disabled="currentQuestionnaire.locked"
          @click="toggleTrackChanges(true)"
          class="default-input primary text-none"
          :loading="trackChangesLoading"
        >
          Track Changes
        </v-btn>
        <span v-if="!currentQuestionnaire.locked"
          >Tracking changes will notify you of every change made in the
          questionnaire</span
        >
        <span v-else>
          Need to unlock the questionnaire in order to track changes
        </span>
      </v-tooltip>
      <v-tooltip
        bottom
        v-if="
          currentUser.is_advisor &&
            currentQuestionnaire.track_changes &&
            !currentQuestionnaire.locked
        "
      >
        <v-btn
          slot="activator"
          @click="toggleTrackChanges(false)"
          outline
          class="default-input error--text text-none"
          :loading="trackChangesLoading"
        >
          Untrack Changes
        </v-btn>
        <span
          >Untracking changes will stop notifying you of every change made in
          the questionnaire</span
        >
      </v-tooltip>
      <v-tooltip
        bottom
        v-if="
          active === 0 &&
            currentUser.is_advisor &&
            (questionnairePartiallySubmitted ||
              currentQuestionnaire.completed) &&
            !currentQuestionnaire.locked
        "
      >
        <v-btn
          slot="activator"
          @click="unsubmitQuestionnaire()"
          outline
          class="default-input primary--text text-none"
        >
          Mark Unsubmitted
        </v-btn>
        <span
          >Marking this unsubmitted will allow client to change any answer</span
        >
      </v-tooltip>
      <v-btn
        v-if="currentQuestionnaire.is_draft"
        @click="sendDraft()"
        class="default-input primary text-none"
        :loading="draftSending"
      >
        Send to Client
      </v-btn>
    </v-layout>

    <!-- NOTE @chris This is redundant, we should remove. -->
    <v-alert
      v-if="!currentUser.is_advisor"
      :value="true"
      outline
      block
      :icon="$vuetify.breakpoint.smAndUp ? 'info' : ''"
      color="primary"
      class="text-xs-left"
    >
      Click on a section to expand. If you have questions, want to change your
      answer, or add additional information, message us using the message icon
      on the top right.
    </v-alert>

    <!-- Note: @chris Should consider removing this and the flag. -->
    <v-alert
      v-else-if="active === 1 && oldDocumentChecklist"
      :value="true"
      outline
      block
      :icon="$vuetify.breakpoint.smAndUp ? 'info' : ''"
      color="info"
      class="text-xs-left"
    >
      This is a list of all documents uploaded through the
      {{ projectViewEnabled ? 'project' : 'questionnaire' }}. You can click a
      document to preview or download if preview is not supported. If you no
      longer need an item from your client, you can check off the item to mark
      as completed.
    </v-alert>

    <!-- NOTE @chris This is redundant, we should remove. -->
    <v-alert
      v-else-if="active === 2"
      :value="true"
      outline
      block
      :icon="$vuetify.breakpoint.smAndUp ? 'info' : ''"
      color="info"
      class="text-xs-left"
    >
      This is a list of all activities regarding this questionnaire.
    </v-alert>

    <!-- NOTE @chris Feedback to be translated to UI. -->
    <v-alert
      v-else-if="active === 3"
      :value="true"
      outline
      block
      :icon="$vuetify.breakpoint.smAndUp ? 'info' : ''"
      color="info"
      class="text-xs-left"
    >
      This is a list of all documents uploaded outside of
      {{ projectViewEnabled ? 'projects' : 'questionnaires' }}. You can click a
      document to preview or download if preview is not supported. If you want
      to attach it to the
      {{ projectViewEnabled ? 'project' : 'questionnaire' }}, use the "Attach"
      button.
    </v-alert>

    <!-- Partial: 0: Sections -->
    <v-layout v-if="active === 0" column>
      <v-expansion-panel
        class="my-1 elevation-0 pb-4"
        :class="$vuetify.breakpoint.smAndUp ? 'px-2 pt-4' : ''"
      >
        <v-expansion-panel-content
          v-for="(section, i) in sections"
          :key="section.id"
          class="mb-2"
        >
          <div slot="header" class="expansion-panel__header" :key="i">
            <QuestionnaireSectionHeader
              :current-questionnaire="currentQuestionnaire"
              :section="section"
              :active="active"
            />
          </div>

          <!-- Section: Custom & Agreement signature -->
          <v-card
            class="expansion-card__content pa-3"
            v-if="
              sectionKey(section) === 'agreement_signature' ||
                sectionKey(section) === 'custom'
            "
            flat
          >
            <!-- State: Editing -->
            <sc-flex v-if="engagementLetterEditing" :is-column="true" :gap="8">
              <quill-editor
                id="engagement_letter_editing"
                v-model="section.custom_element"
                :options="editorOptions"
                class="ql-message-input default-input"
              />
              <sc-button-group align="right">
                <sc-button
                  @click="saveEngagementSection(section)"
                  type="primary"
                  >Save Letter</sc-button
                >
              </sc-button-group>
            </sc-flex>

            <!-- State: Viewing -->
            <v-layout column class="text-xs-center" v-else>
              <v-layout class="my-4">
                <sx-html :text="section.custom_element" />
              </v-layout>
              <v-layout row wrap>
                <v-flex
                  xs12
                  md6
                  lg4
                  v-for="signature_box in section.engagement_signatures"
                  :key="signature_box.id"
                >
                  <v-layout column>
                    <label class="font-weight-bold subheading">
                      {{ signature_box.user_name }}
                    </label>
                    <div
                      v-if="!signature_box.signature"
                      class="my-2 dark-grey--text"
                    >
                      {{ $t('questionnaire.unsigned') }}
                    </div>
                    <div
                      v-if="signature_box.signature === 'Marked Not Needed'"
                      class="darkgrey--text py-2"
                    >
                      Marked Not Needed
                      <v-icon
                        class="error--text ml-2"
                        size="18"
                        style="cursor: pointer"
                        @click="unmarkNotNeeded(signature_box)"
                        v-if="currentUser.is_advisor"
                        >cancel</v-icon
                      >
                    </div>
                    <v-btn
                      v-else-if="
                        currentUser.is_advisor && !signature_box.signature
                      "
                      @click="markNotNeeded(signature_box)"
                      outline
                      class="default-input primary--text text-none"
                    >
                      Mark Not Needed
                    </v-btn>
                    <div v-else>
                      <div class="darkgrey--text">
                        {{ $t('questionnaire.signed') }}:
                      </div>
                      <div class="signature">{{ signature_box.signature }}</div>
                      <div class="darkgrey--text">
                        {{ moment(signature_box.signed_at).format('ll') }}
                      </div>
                      <v-btn
                        @click="unmarkNotNeeded(signature_box)"
                        outline
                        class="default-input error--text text-none mb-4"
                        v-if="currentUser.is_advisor"
                      >
                        Remove Signature
                      </v-btn>
                    </div>
                  </v-layout>
                </v-flex>
              </v-layout>

              <!-- Actions: Advisor -->
              <v-layout column align-end v-if="currentUser.is_advisor">
                <v-tooltip bottom v-if="signatureExists(section)">
                  <v-btn
                    slot="activator"
                    outline
                    class="default-input primary--text text-none"
                    disabled
                  >
                    <v-icon class="mr-2">edit</v-icon> Edit
                  </v-btn>
                  <span>You cannot edit an agreement after it was signed</span>
                </v-tooltip>
                <v-btn
                  @click="editEngagementLetterConfirmationDialogOpened = true"
                  outline
                  class="default-input primary--text text-none"
                  v-else
                >
                  <v-icon class="mr-2">edit</v-icon> Edit
                </v-btn>
              </v-layout>
            </v-layout>
          </v-card>

          <!-- Section: Contact -->
          <v-card
            class="expansion-card__content"
            v-else-if="sectionKey(section) === 'contact'"
            flat
          >
            <v-card-text class="text-xs-left mx-2">
              <v-flex class="mb-2">
                <span class="font-weight-bold">Primary Contact Name:</span>
                <span>{{ currentCompany.user.full_name }}</span>
              </v-flex>
              <v-flex class="mb-2">
                <span class="font-weight-bold">Primary Contact Email:</span>
                <span>{{ currentCompany.user.email }}</span>
              </v-flex>
              <v-flex class="mb-2">
                <span class="font-weight-bold">Cell Phone Number:</span>
                <span v-if="currentCompany.user.phone_number">{{
                  currentCompany.user.phone_number
                }}</span>
                <span v-else class="darkgrey--text">Blank</span>
              </v-flex>
              <v-flex class="mb-2">
                <span class="font-weight-bold">Address:</span>
                <span v-if="!isEmpty(currentCompany.formatted_address)">{{
                  currentCompany.formatted_address
                }}</span>
                <span v-else class="darkgrey--text">Blank</span>
              </v-flex>
              <v-flex class="mb-2">
                <span class="font-weight-bold">Receive SMS notification?</span>
                <span
                  v-if="currentCompany.user.preferred_contact_method === 'sms'"
                  >Yes</span
                >
                <span v-else class="darkgrey--text">No</span>
              </v-flex>
            </v-card-text>
          </v-card>

          <!-- Section: Delivery -->
          <v-card
            class="expansion-card__content"
            v-else-if="sectionKey(section) === 'delivery'"
            flat
          >
            <div class="px-3 pb-3" v-if="currentUser.is_advisor">
              <TaxReturnTable
                :currentCompany="currentCompany"
                :currentSectionId="section.id"
                :currentQuestionnaire="currentQuestionnaire"
              />
            </div>
          </v-card>

          <!-- Section Questionnaire -->
          <v-card
            class="expansion-card__content"
            v-else-if="
              sectionKey(section) === 'questionnaire' && currentQuestionnaire
            "
            flat
          >
            <v-layout
              column
              v-for="(question, i) in sectionQuestionsWithoutFollowUp(section)"
              :key="question.id"
            >
              <QuestionnaireQuestionView
                :key="i"
                :current-questionnaire="currentQuestionnaire"
                :question="question"
                @open-comment-dialog="openCommentDialog"
                @toggle-completed="toggleCompleted"
                @delete-question="openDeleteQuestionConfirmationDialog"
                @preview-document="previewDocument"
                :allow-file-selection="allowFileSelection"
                :show-question-actions="currentUser.is_advisor"
              />
            </v-layout>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-layout>

    <!-- Partial: 1: Documents -->
    <v-layout column v-else-if="active === 1">
      <div v-if="!oldDocumentChecklist">
        <DocumentsNeedSplittingSection
          :current-company="currentCompany"
          :current-questionnaire="currentQuestionnaire"
          @refresh-questionnaire="refreshQuestionnaire"
          @refresh-questionnaire-until-documents-are-processed="
            refreshQuestionnaireUntilDocumentsAreProcessed()
          "
        />

        <NewDocumentChecklistSectionAdminView
          :current-company="currentCompany"
          :current-questionnaire="currentQuestionnaire"
          @save-question="saveQuestion"
          @open-comment-dialog="openCommentDialog"
          @refresh-questionnaire="refreshQuestionnaire"
          @refresh-questionnaire-until-documents-are-processed="
            refreshQuestionnaireUntilDocumentsAreProcessed()
          "
        />
      </div>

      <v-layout v-else row>
        <v-flex xs5 class="outlined pa-3 mr-4 text-xs-left">
          <h3 class="font-weight-bold text-xs-left mt-2 mb-3">
            Document Checklist
            <v-tooltip bottom>
              <v-icon class="primary--text" slot="activator" size="18"
                >help</v-icon
              >
              <span>Mark off completed items</span>
            </v-tooltip>
          </h3>
          <DocumentChecklistSectionAdminView
            :current-questionnaire="currentQuestionnaire"
            :selected-question="selectedQuestion"
            @delete-question="openDeleteQuestionConfirmationDialog"
            @preview-document="previewDocument"
            @toggle-completed="toggleCompleted"
            :all-documents="allExtractedDocuments"
          />
        </v-flex>
        <v-flex xs7 class="outlined pa-3">
          <v-layout align-center>
            <h3 class="font-weight-bold text-xs-left">Uploaded Documents</h3>
            <v-spacer class="hidden-sm-and-down" />
            <v-flex xs12 sm6>
              <v-text-field
                v-model="documentSearch"
                class="default-input subheading"
                solo
                hide-details
                placeholder="Search"
              />
            </v-flex>
          </v-layout>
          <v-data-table
            :search="documentSearch"
            :items="parentDocuments"
            :headers="documentHeaders"
            disable-initial-sort
            item-key="name"
          >
            <template slot="items" slot-scope="props">
              <tr :key="props.index">
                <td class="text-xs-left accent--text">
                  <v-layout
                    align-center
                    v-if="
                      isEmpty(childDocuments(props.item)) ||
                        childrenSinglePage(props.item)
                    "
                  >
                    <i class="material-icons-outlined documents__icon"
                      >insert_drive_file</i
                    >
                    <v-layout
                      class="ml-2"
                      style="cursor: pointer"
                      align-center
                      @click="previewDocument(props.item)"
                      wrap
                    >
                      <div>{{ getDocumentName(props.item.source) }}</div>
                      <v-chip
                        small
                        v-if="
                          props.item.name !==
                            getDocumentName(props.item.source) &&
                            props.item.form_name_verified === true &&
                            !isEmpty(props.item.detailed_name)
                        "
                        >{{ props.item.detailed_name }}</v-chip
                      >
                      <v-chip
                        small
                        v-if="
                          childrenSinglePage(props.item) &&
                            !isEmpty(
                              childDocuments(props.item)[0].detailed_name,
                            )
                        "
                        >{{
                          childDocuments(props.item)[0].detailed_name
                        }}</v-chip
                      >
                    </v-layout>
                  </v-layout>
                  <v-menu
                    transition="slide-y-transition"
                    bottom
                    nudge-bottom="30"
                    class="my-1"
                    v-else
                  >
                    <v-layout slot="activator" align-center>
                      <i class="material-icons-outlined documents__icon"
                        >insert_drive_file</i
                      >
                      <v-layout
                        class="ml-2"
                        style="cursor: pointer"
                        align-center
                        wrap
                      >
                        <div>{{ getDocumentName(props.item.source) }}</div>
                        <v-chip small class="caption"
                          >{{ childDocuments(props.item).length }} Form{{
                            childDocuments(props.item).length > 1 ? 's' : ''
                          }}
                          Recognized</v-chip
                        >
                        <v-chip
                          small
                          v-if="
                            props.item.name !==
                              getDocumentName(props.item.source) &&
                              props.item.detailed_name
                          "
                          >{{ props.item.detailed_name }}</v-chip
                        >
                      </v-layout>
                    </v-layout>
                    <v-list>
                      <v-list-tile
                        :key="0"
                        @click="previewDocument(props.item)"
                        class="pa-0"
                      >
                        View Original Document
                      </v-list-tile>
                      <v-list-tile
                        :key="childDocument.id"
                        v-for="(childDocument, i) in childDocuments(props.item)"
                        @click="previewDocument(childDocument)"
                        class="pa-0"
                      >
                        {{ getDocumentName(childDocument.source)
                        }}<v-chip
                          small
                          v-if="
                            childDocument !==
                              getDocumentName(childDocument.source) &&
                              !isEmpty(childDocument.detailed_name)
                          "
                          >{{ childDocument.detailed_name }}</v-chip
                        >
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </td>
                <td class="text-xs-left no-wrap">
                  <span class="darkgrey--text">{{
                    moment(props.item.created_at).format('ll')
                  }}</span>
                </td>
                <td class="text-xs-left no-wrap">
                  <span v-if="props.item.exportedDate" class="darkgrey--text">
                    Exported {{ moment(props.item.exportedDate).fromNow() }}
                  </span>
                </td>
              </tr>
            </template>
            <template slot="no-data">
              <v-layout class="text-xs-center grey--text">
                <v-flex>
                  <v-icon size="16" color="grey"> priority_high </v-icon>
                  <span class="ml-1">None</span>
                </v-flex>
              </v-layout>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-layout>

    <!-- Partial: 2: Activity Log -->
    <v-layout column v-else-if="active == 2">
      <ActivityLog
        :questionnaire-id="currentQuestionnaire.id"
        :current-company-id="currentQuestionnaire.company_id"
        dialog-opened
      />
    </v-layout>

    <!-- Partial: 2: Unattached -->
    <v-layout column v-else-if="active === 3">
      <v-layout align-center>
        <span class="font-weight-bold text-xs-left"
          >Documents uploaded outside of questionnaire</span
        >
        <v-spacer class="hidden-sm-and-down" />
        <v-btn
          class="text-capitalize primary mr-2"
          @click="attachToQuestionnaire(selectedDocuments)"
          :disabled="isEmpty(selectedDocuments)"
        >
          Attach Selected ({{ selectedDocuments.length }})
        </v-btn>
        <v-flex xs12 sm6>
          <v-text-field
            v-model="documentSearch"
            class="default-input subheading"
            solo
            hide-details
            placeholder="Search Document"
          />
        </v-flex>
      </v-layout>
      <v-data-table
        select-all
        v-model="selectedDocuments"
        :search="documentSearch"
        :items="recentlyUploadedDocuments"
        :headers="recentlyUploadedDocumentHeaders"
        disable-initial-sort
        item-key="name"
        :loading="documentAttaching"
      >
        <template slot="items" slot-scope="props">
          <tr :key="props.index">
            <td>
              <v-checkbox
                v-model="props.selected"
                primary
                color="lightgrey"
                hide-details
              ></v-checkbox>
            </td>
            <td class="text-xs-left accent--text">
              <v-layout
                align-center
                v-if="
                  isEmpty(childDocuments(props.item)) ||
                    childrenSinglePage(props.item)
                "
              >
                <i class="material-icons-outlined documents__icon"
                  >insert_drive_file</i
                >
                <v-layout
                  class="ml-2"
                  style="cursor: pointer"
                  align-center
                  @click="previewDocument(props.item)"
                  wrap
                >
                  <div>{{ getDocumentName(props.item.source) }}</div>
                  <v-chip
                    small
                    v-if="
                      props.item.name !== getDocumentName(props.item.source) &&
                        props.item.form_name_verified === true &&
                        !isEmpty(props.item.detailed_name)
                    "
                    >{{ props.item.detailed_name }}</v-chip
                  >
                  <v-chip
                    small
                    v-if="
                      childrenSinglePage(props.item) &&
                        !isEmpty(childDocuments(props.item)[0].detailed_name)
                    "
                    >{{ childDocuments(props.item)[0].detailed_name }}</v-chip
                  >
                </v-layout>
              </v-layout>
              <v-menu
                transition="slide-y-transition"
                bottom
                nudge-bottom="30"
                class="my-1"
                v-else
              >
                <v-layout slot="activator" align-center>
                  <i class="material-icons-outlined documents__icon"
                    >insert_drive_file</i
                  >
                  <v-layout
                    class="ml-2"
                    style="cursor: pointer"
                    align-center
                    wrap
                  >
                    <div>{{ getDocumentName(props.item.source) }}</div>
                    <v-chip small class="caption"
                      >{{ childDocuments(props.item).length }} Form{{
                        childDocuments(props.item).length > 1 ? 's' : ''
                      }}
                      Recognized</v-chip
                    >
                    <v-chip
                      small
                      v-if="
                        props.item.name !==
                          getDocumentName(props.item.source) &&
                          props.item.detailed_name
                      "
                      >{{ props.item.detailed_name }}</v-chip
                    >
                  </v-layout>
                </v-layout>
                <v-list>
                  <v-list-tile
                    :key="0"
                    @click="previewDocument(props.item)"
                    class="pa-0"
                  >
                    View Original Document
                  </v-list-tile>
                  <v-list-tile
                    :key="i + 1"
                    v-for="(childDocument, i) in childDocuments(props.item)"
                    @click="previewDocument(childDocument)"
                    class="pa-0"
                  >
                    {{ getDocumentName(childDocument.source)
                    }}<v-chip
                      small
                      v-if="
                        childDocument !==
                          getDocumentName(childDocument.source) &&
                          !isEmpty(childDocument.detailed_name)
                      "
                      >{{ childDocument.detailed_name }}</v-chip
                    >
                  </v-list-tile>
                </v-list>
              </v-menu>
            </td>
            <td class="text-xs-left no-wrap">
              <span class="darkgrey--text">{{ props.item.folder }}</span>
            </td>
            <td class="text-xs-left no-wrap">
              <span class="darkgrey--text">{{
                moment(props.item.created_at).format('ll')
              }}</span>
            </td>
            <td class="text-xs-left no-wrap">
              <v-btn
                class="text-capitalize primary"
                @click="attachToQuestionnaire([props.item])"
              >
                Attach
              </v-btn>
            </td>
          </tr>
        </template>
        <template slot="no-data">
          <v-layout class="text-xs-center grey--text">
            <v-flex>
              <v-icon size="16" color="grey"> priority_high </v-icon>
              <span class="ml-1">None</span>
            </v-flex>
          </v-layout>
        </template>
      </v-data-table>
    </v-layout>
  </sc-flex>
</template>
<script>
import { getEditorOptions } from '@/constants/editor';
import API from '@/api';
import { mapGetters } from 'vuex';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import uniqBy from 'lodash/uniqBy';
import moment from 'moment';
import PreviewDocument from './PreviewDocument';
import { supportedExtensionsForPreview } from '@/constants/variables';
import heicConvert from 'heic-convert';
import DocumentChecklistSectionAdminView from './DocumentChecklistSectionAdminView';
import CommentDialog from '@/components/dialogs/CommentDialog';
import QuestionnaireQuestionView from '@/components/QuestionnaireQuestionView';
import QuestionnaireSectionHeader from '@/components/QuestionnaireSectionHeader';
import QuestionnaireMixin from '@/mixins/QuestionnaireMixin';
import FirmPreferenceMixins from '../mixins/FirmPreferenceMixins';
import DocumentMixin from '@/mixins/DocumentMixin';
import ConfirmationDialog from '@/components/ConfirmationDialog';
import DocumentsNeedSplittingSection from '@/components/DocumentsNeedSplittingSection';
import NewDocumentChecklistSectionAdminView from '@/components/NewDocumentChecklistSectionAdminView';
import ActivityLog from '@/components/ActivityLog';
import TaxReturnsMixin from '@/mixins/TaxReturnsMixin';
import TaxReturnTable from '@/components/returns/TaxReturnTable';
import SxHtml from '@/components/sx/SxHtml';
import UtilsMixins from '@/mixins/UtilsMixins';

export default {
  name: 'SmartQuestionnaireView',
  mixins: [
    QuestionnaireMixin,
    FirmPreferenceMixins,
    TaxReturnsMixin,
    DocumentMixin,
    UtilsMixins,
  ],
  props: {
    currentQuestionnaire: {
      required: true,
      type: Object,
    },
    currentCompany: {
      required: true,
      type: Object,
    },
    defaultTab: {
      type: String,
    },
    allowFileSelection: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  components: {
    PreviewDocument,
    DocumentChecklistSectionAdminView,
    CommentDialog,
    QuestionnaireQuestionView,
    QuestionnaireSectionHeader,
    ConfirmationDialog,
    DocumentsNeedSplittingSection,
    NewDocumentChecklistSectionAdminView,
    ActivityLog,
    TaxReturnTable,
    SxHtml,
  },
  data() {
    return {
      selectedDocuments: [],
      supportedExtensionsForPreview,
      active: 0,
      selectableDocuments: [],
      deletingQuestion: false,
      documentSearch: '',
      exportedDocs: [],
      documentActualName: '',
      commentDialogOpened: false,
      documentData: '',
      selectedQuestion: null,
      documentExtension: '',
      documentsLoading: false,
      completionLoading: false,
      signatureConfirmationDialogOpened: false,
      questionnaireCompletedConfirmationDialogOpened: false,
      deleteQuestionConfirmationDialogOpened: false,
      manualSignatureConfirmationDialogOpened: false,
      currentSection: '',
      selectedItem: null,
      newComment: '',
      newOption: '',
      previewType: '',
      previewLoaded: false,
      documentPreviewData: null,
      previewRotation: 0,
      previewDialogOpened: false,
      newName: '',
      renameFile: false,
      documentHeaders: [
        {
          text: 'Name (Click to preview or download)',
          align: 'left',
          sortable: true,
          value: 'name',
          width: '90%',
        },
        {
          text: 'Uploaded at',
          align: 'left',
          value: 'created_at',
          sortable: true,
          width: '5%',
        },
        {
          text: '',
          align: 'right',
          value: 'exported',
          sortable: true,
          width: '5%',
        },
      ],
      engagementLetterEditing: false,
      editEngagementLetterConfirmationDialogOpened: false,
      recentlyUploadedDocuments: [],
      recentlyUploadedDocumentHeaders: [
        {
          text: 'Name (Click to preview or download)',
          align: 'left',
          sortable: true,
          value: 'name',
          width: '55%',
        },
        {
          text: 'Folder location',
          align: 'left',
          value: 'folder',
          sortable: true,
          width: '20%',
        },
        {
          text: 'Uploaded at',
          align: 'left',
          value: 'created_at',
          sortable: true,
          width: '10%',
        },
        {
          text: 'Actions',
          align: 'center',
          value: 'exported',
          sortable: true,
          width: '5%',
        },
      ],
      documentAttaching: false,
      currentSignatureRequest: null,
      trackChangesLoading: false,
      refreshCount: 5,
      draftSending: false,
    };
  },
  computed: {
    editorOptions() {
      return getEditorOptions('Engagement Letter');
    },
    ...mapGetters({
      currentUser: 'user',
      currentFirm: 'currentFirm',
    }),

    uploadedTaxReturn() {
      if (this.deliverySection(this.currentQuestionnaire)) {
        return this.deliverySection(this.currentQuestionnaire)
          .signature_request;
      } else {
        return null;
      }
    },
  },
  methods: {
    isEmpty,
    moment,
    get,
    heicConvert,
    startReviewSignatureRequest() {
      this.currentSignatureRequest = this.uploadedTaxReturn;
      this.reviewSignatureRequestDialogOpened = true;
    },
    signatureExists(section) {
      return !isEmpty(
        section.engagement_signatures.filter(
          signature => !isEmpty(signature.signature),
        ),
      );
    },
    openRelevantConversation() {
      this.commentDialogOpened = false;
      this.$emit(
        'openSpecificConversation',
        this.currentCompany.relevant_conversation_id,
      );
    },
    async sendDraft() {
      try {
        this.draftSending = true;
        const response = await API.questionnaire.sendQuestionnaireNotifications(
          {
            questionnaireIds: [this.currentQuestionnaire.id],
          },
        );
        if (response.data.error) {
          this.$store.dispatch('application/setErrorNotification', {
            message: 'There was a problem sending the draft.',
          });
        } else {
          this.$store.dispatch('application/setSuccessNotification', {
            message: 'Successfully sent the draft',
          });
          this.$emit('close-questionnaire-dialog');
        }
      } catch (e) {
        console.log(e);
        this.$store.dispatch('application/setErrorNotification', {
          message: 'There was a problem sending the draft.',
        });
      } finally {
        this.$emit('refresh-current-questionnaire', this.currentQuestionnaire);
        this.$emit('refresh-questionnaires');
        this.draftSending = false;
      }
    },
    async toggleTrackChanges(trackChange) {
      this.trackChangesLoading = true;
      await API.questionnaire.saveQuestionnaire({
        company_id: this.currentCompany.id,
        id: this.currentQuestionnaire.id,
        track_changes: trackChange,
      });
      this.currentQuestionnaire.track_changes = trackChange;
      this.$emit('refresh-current-questionnaire', this.currentQuestionnaire);
      this.$emit('refresh-questionnaires');
      this.trackChangesLoading = false;
    },
    async unsubmitQuestionnaire() {
      await API.questionnaire.unsubmitQuestionnaire({
        companyId: this.currentCompany.id,
        id: this.currentQuestionnaire.id,
      });
      this.$emit('refresh-current-questionnaire', this.currentQuestionnaire);
    },
    async saveEngagementSection(section) {
      try {
        const updatedSection = {
          sectionId: section.id,
          questionnaireId: this.currentQuestionnaire.id,
          companyId: this.currentCompany.id,
          markedCompleted: section.marked_completed,
          customElement: section.custom_element,
        };

        await API.questionnaire.saveSection(updatedSection);

        this.$store.dispatch('application/setSuccessNotification', {
          message: 'Successfully saved the engagement letter',
        });
      } catch (error) {
        console.error(error);
        this.$store.dispatch('application/setErrorNotification', {
          message: 'There was a problem saving the engagement letter.',
        });
      } finally {
        this.engagementLetterEditing = false;
        this.$emit('refresh-current-questionnaire', this.currentQuestionnaire);
      }
    },
    async markNotNeeded(signatureBox) {
      try {
        this.engagementLoading = true;
        if (!this.preview) {
          signatureBox.signature = 'Marked Not Needed';
          await API.questionnaire.signAgreement({
            questionnaireId: this.currentQuestionnaire.id,
            companyId: this.currentQuestionnaire.company_id,
            signature: 'Marked Not Needed',
            signatureId: signatureBox.id,
          });
          this.$emit(
            'refresh-current-questionnaire',
            this.currentQuestionnaire,
          );
        }

        this.$store.dispatch('application/setSuccessNotification', {
          message: 'Successfully Marked Not Needed',
        });
      } catch (e) {
        console.log(e);
        this.$store.dispatch('application/setErrorNotification', {
          message: 'There was a problem with the request.',
          errorToSend: e,
          userEmail: this.currentUser.email,
        });
      } finally {
        this.engagementLoading = false;
      }
    },
    async unmarkNotNeeded(signatureBox) {
      await API.questionnaire.removeSignature({
        signatureId: signatureBox.id,
        questionnaireId: this.currentQuestionnaire.id,
        companyId: this.currentQuestionnaire.company_id,
      });
      this.$emit('refresh-current-questionnaire', this.currentQuestionnaire);

      this.engagementLoading = false;
    },
    async onSelectFiles(documents, question) {
      question.answer =
        '&!&' +
        documents
          .map(doc => {
            const document_location = this.currentCompany.upload_link.replace(
              'https://www.dropbox.com/home/',
              '',
            );
            return doc.source.replace('/' + document_location + '/', '');
          })
          .join('&!&');

      await API.questionnaire.answerQuestion({
        id: question.id,
        answer: question.answer,
        companyId: this.currentCompany.id,
      });
    },
    async getLinkAndDownloadFile() {
      try {
        const response = await API.integration.downloadDocument({
          companyId: this.currentQuestionnaire.company_id,
          link: this.selectedItem.source,
        });
        this.downloadDocumentByLink(
          response.data.document.data.link,
          this.selectedItem.name,
        );
      } catch (e) {
        console.log(e);
        this.$store.dispatch('application/setErrorNotification', {
          message: 'There was a problem downloading the document.',
        });
      }
    },
    refreshQuestionnaire(callback) {
      this.$emit(
        'refresh-current-questionnaire',
        this.currentQuestionnaire,
        callback,
      );
    },
    async refreshQuestionnaireUntilDocumentsAreProcessed() {
      try {
        this.$emit('refresh-current-questionnaire', this.currentQuestionnaire);
        // Wait 3 seconds before checking if everything has been processed and detailed name has been extracted
        this.sleep(3000).then(() => {
          if (
            this.currentQuestionnaire.extracted_documents.some(
              document =>
                moment(document.created_at) > moment().subtract(5, 'minutes') &&
                document.status === 'processing',
            )
          ) {
            console.log('refreshing documents');
            this.refreshQuestionnaireUntilDocumentsAreProcessed();
            this.refreshCount = 200;
          } else {
            if (this.refreshCount > 0) {
              this.refreshQuestionnaireUntilDocumentsAreProcessed();
              this.refreshCount -= 1;
            } else {
              this.refreshCount = 200;
            }
          }
        });
        console.log('checking documents');
      } catch (e) {
        console.log(e);
      }
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    async previewDocument(document) {
      this.selectedItem = document;
      this.previewType = '';
      this.previewLoaded = false;
      this.documentPreviewData = '';
      this.previewRotation = 0;
      this.previewType = this.endsWithAny(
        this.supportedExtensionsForPreview,
        document.source,
      );
      if (this.previewType) {
        if (this.previewType === 'pdf') {
          this.currentPage = 1;
          this.pdfLoaded = false;
        }
        this.previewDialogOpened = true;
      }
      try {
        const response = await API.integration.downloadDocument({
          companyId: this.currentQuestionnaire.company_id,
          link: document.source,
        });
        if (response.data.document) {
          if (this.previewType === 'heic') {
            this.documentPreviewData = await this.convertToJPEG(
              response.data.document.data.link,
            );
          } else {
            this.documentPreviewData = response.data.document.data.link;
          }
          this.previewLoaded = true;
          this.getExportedDocs();
        } else {
          console.log(response.data.error);
          this.$store.dispatch('application/setErrorNotification', {
            message: 'There was a problem downloading the document.',
          });
        }
        if (isEmpty(this.previewType))
          this.downloadDocumentByLink(this.documentPreviewData, document.name);
      } catch (e) {
        console.log(e);
        this.$store.dispatch('application/setErrorNotification', {
          message: 'There was a problem downloading the document.',
        });
      }
    },
    async convertToJPEG(url) {
      const output = await fetch(url).then(async data => {
        const buffer = Buffer.from(await data.arrayBuffer());
        return heicConvert({ buffer, format: 'JPEG' });
      });
      const imgBase64 = btoa(
        output.reduce(
          (data, byte) => `${data}${String.fromCharCode(byte)}`,
          '',
        ),
      );
      return `data:image/png;base64,${imgBase64}`;
    },
    async getExportedDocs() {
      try {
        const apiResponse = await API.questionnaire.getQuestionnaireExportedDocs(
          {
            id: this.currentCompany.id,
          },
        );

        this.exportedDocs = apiResponse.data;
      } catch (e) {
        console.error(e);
        this.exportedDocs = [];
      }
    },
    getUser(user_id) {
      let user = this.companies.map(a => a.user).find(u => u.id === user_id);
      if (user) {
        return user.full_name;
      }
      return '';
    },
    async addComment() {
      if (this.newComment) {
        const response = await API.questionnaire.addQuestionnaireComment({
          text: this.newComment,
          questionnaireQuestionId: this.selectedQuestion.id,
          companyId: this.currentCompany.id,
        });
        if (response.data.id) {
          this.selectedQuestion.filtered_questionnaire_comments.push(
            response.data,
          );
          this.newComment = '';
        } else {
          this.$store.dispatch('application/setErrorNotification', {
            message: 'There was a problem.',
          });
          console.log(response.data.error);
        }
      }
    },
    async getDocumentsUploadedOutsideOfQuestionnaire() {
      const response = await API.integration.getDocumentsUploadedOutsideOfQuestionnaire(
        this.currentCompany.id,
      );
      this.recentlyUploadedDocuments = response.data.map(a => {
        let folder = a.source.split('/');
        folder.shift();
        folder.shift();
        folder.shift();
        folder.pop();
        return {
          selected: false,
          source: a.source,
          name: a.name,
          folder: folder.join('/'),
          id: a.id,
          created_at: a.created_at,
        };
      });
    },
    async attachToQuestionnaire(items) {
      try {
        this.documentAttaching = true;
        const response1 = await API.questionnaire.attachToQuestionnaire({
          extractedDocumentIds: items.map(a => a.id),
          id: this.currentQuestionnaire.id,
          companyId: this.currentCompany.id,
        });
        if (response1.data.error) {
          this.$store.dispatch('application/setErrorNotification', {
            message: response1.data.error,
          });
        } else {
          this.$store.dispatch('application/setSuccessNotification', {
            message: 'Successfully attached.',
          });
          this.$emit(
            'refresh-current-questionnaire',
            this.currentQuestionnaire,
          );
        }
      } catch (e) {
        console.log(e);
        this.$store.dispatch('application/setErrorNotification', {
          message:
            'There was a problem while attaching. Please refresh the page and try again.',
        });
      } finally {
        await this.getDocumentsUploadedOutsideOfQuestionnaire();
        this.documentAttaching = false;
      }
    },
    openCommentDialog(question) {
      this.selectedQuestion = question;
      this.commentDialogOpened = true;
    },
    answerToList(question) {
      if (question.answer) {
        return question.answer.replaceAll('"', '').split(', ');
      } else {
        return [];
      }
    },
    sectionQuestionsWithoutFollowUp(section) {
      return section.questionnaire_questions
        .filter(q => !q.follow_up_question_id)
        .sort((a, b) => a.order - b.order);
    },
    zoomOut() {
      this.heightStart = 0;
      this.widthStart = 0;
      this.heightEnd = 0;
      this.widthEnd = 0;
    },
    async saveQuestion(question) {
      const response = await API.questionnaire.answerQuestion({
        id: question.id,
        answer: question.answer,
        answerBy: question.answer_by,
        companyId: this.currentQuestionnaire.company_id,
      });

      let cachedQuestion;
      cachedQuestion = this.currentQuestionnaire.questionnaire_questions.find(
        q => q.id === question.id,
      );
      cachedQuestion.answer = question.answer;
      cachedQuestion.answer_by = question.answer_by;

      this.$emit('refresh-current-questionnaire', this.currentQuestionnaire);
    },

    async toggleCompleted(question) {
      let newAnswer =
        question.answer === 'Marked Completed' ? '' : 'Marked Completed';
      const response = await API.questionnaire.answerQuestion({
        id: question.id,
        answer: newAnswer,
        companyId: this.currentQuestionnaire.company_id,
      });
      let cachedQuestion;
      cachedQuestion = this.currentQuestionnaire.questionnaire_questions.find(
        q => q.id === question.id,
      );
      cachedQuestion.answer = newAnswer;
      this.$emit('refresh-current-questionnaire', this.currentQuestionnaire);
    },
    openDeleteQuestionConfirmationDialog(question) {
      this.selectedQuestion = question;
      this.deleteQuestionConfirmationDialogOpened = true;
    },
    async deleteQuestion(id) {
      this.deletingQuestion = true;
      const response = await API.questionnaire.deleteQuestion({
        id,
        questionnaireId: this.currentQuestionnaire.id,
        companyId: this.currentQuestionnaire.company_id,
      });

      if (response.data.error) {
        console.log(response.data.error);
        this.$store.dispatch('application/setErrorNotification', {
          message: 'There was a problem deleting the question.',
        });
      } else {
        this.$store.dispatch('application/setSuccessNotification', {
          message: 'You have deleted the question.',
        });
        let index = this.currentQuestionnaire.questionnaire_questions.findIndex(
          q => q.id === id,
        );
        this.currentQuestionnaire.questionnaire_questions.splice(index, 1);
        this.$emit('refresh-current-questionnaire', this.currentQuestionnaire);
      }
      this.deletingQuestion = false;
      this.deleteQuestionConfirmationDialogOpened = false;
    },
  },
  async created() {
    if (this.defaultTab && this.defaultTab === 'documents') {
      this.active = 1;
    }
    this.getDocumentsUploadedOutsideOfQuestionnaire();
    if (this.childQuestionnaire) {
      this.selectableDocuments = this.allExtractedDocuments.concat(
        this.childQuestionnaire.extracted_documents,
      );
    } else {
      this.selectableDocuments = this.allExtractedDocuments;
    }
    this.getExportedDocs();

    this.currentQuestionnaire.questionnaire_questions.forEach(question => {
      if (question.question_type === 'upload') {
        if (question.answer) {
          const answers = question.answer.split('&!&');
          question.uploaded_documents = uniqBy(
            this.selectableDocuments,
            'source',
          ).filter(doc => {
            const document_location = this.currentCompany.upload_link.replace(
              'https://www.dropbox.com/home/',
              '',
            );
            return answers.includes(
              doc.source.replace('/' + document_location + '/', ''),
            );
          });
        } else {
          question.uploaded_documents = [];
        }
      }
    });
  },
};
</script>

<style lang="postcss">
.signature {
  font-family: 'Cedarville Cursive', cursive;
  font-size: 1.8em;
}
.outlined {
  border-radius: 10px 10px 10px 10px;
  border: solid 0.2px #d3d3d3 !important;
}
.split-documents-alert {
  width: 100%;
}
</style>
